import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";

import Feedback from "../models/feedback.model";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class FeedbackService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/feedbacks";
  contentRef: AngularFirestoreCollection<Feedback>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.contentRef = db.collection(this.dbPath);

    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;
    });
  }

  getFeedbacks(limit?: number, cursor?: any): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      // .where("status", "==", 1)
      .orderBy("updatedOn", "desc");

    ref = limit ? ref.limit(limit) : ref.limit(10);

    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  getMyFeedbacks(uid: string, limit?: number, cursor?: any): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("createdBy", "==", uid)
      .orderBy("updatedOn", "desc");

    ref = limit ? ref.limit(limit) : ref.limit(10);

    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  get(id: string) {
    return this.contentRef.doc(id).valueChanges();
  }

  getById(id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath).doc(id);

    return ref.get();
  }

  create(content: Feedback): any {
    content.imagesUrl = content.imagesUrl ? content.imagesUrl : [];
    content.videoUrl = content.videoUrl ? content.videoUrl : "";
    content.content = content.content ? content.content : "";

    content.status = content.status ? content.status : 0;
    content.isActive = true;
    content.isDeleted = false;
    content.createdOn = new Date();
    content.createdBy = this.userLogin.uid;
    content.updatedOn = new Date();
    content.updatedBy = this.userLogin.uid;
    content.author = this.userLogin;
    content.noLiked = 0;
    content.noComment = 0;
    content.visibility = this.visibility;

    return this.contentRef.add({ ...content }).then((docRef) => {
      content.id = docRef.id;
      return content;
    });
  }

  update(content: Feedback): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.contentRef.doc(content.id).update({
      category: content.category,
      title: content.title,
      description: content.description,
      sourceType: content.sourceType,
      content: content.content ? content.content : "",
      videoUrl: content.videoUrl ? content.videoUrl : "",
      imagesUrl: content.imagesUrl ? content.imagesUrl : [],
      tags: content.tags ? content.tags : [],
      status: content.status ? content.status : 0,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }

  confirm(content: Feedback): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.contentRef.doc(content.id).update({
      status: 2,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }

  delete(id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    return this.contentRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }
}
